import { useCallback, useState } from "react";

export function useTemporaryState<T>(state: T): [T, (value: T, ms: number, setToAfter: T) => void] {
  const [value, setValue] = useState<T>(state);

  const handleSetValue = useCallback((value: T, ms: number, setToAfter: T) => {
    setValue(value);

    setTimeout(() => {
      setValue(setToAfter);
    }, ms);
  }, []);

  return [value, handleSetValue];
}
